// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1cHzV","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__PRi1N"};